import { DefaultFocusStatusModel } from "../../../models/DefaultFocusStatusModel";
import { isFocusable } from "../../../models/utilities/defaultFocusStatusUtilities";
import { KeyboardNavigation } from "./KeyboardNavigation";

export class DefaultNavigation extends KeyboardNavigation {
    findNextFocusableElementWithinSameVariable(
        currentElement: DefaultFocusStatusModel,
        eventKey: string,
    ): DefaultFocusStatusModel | null {
        if (this.isHybridGrid && (eventKey === "ArrowLeft" || eventKey === "ArrowRight")) {
            return this.findNextFocusableElementWithinSameVariableCommonForHybridGrid(
                currentElement,
                eventKey,
            );
        }

        if (this.isHybridGrid && (eventKey === "ArrowDown" || eventKey === "ArrowUp")) {
            return this.findNextFocusableElementWithinSameVariableCommonForSwitchingRowsForHybridGrid(
                currentElement,
                eventKey,
            );
        }

        return null;
    }

    findNextFocusableElementWithinNextVariable(
        currentElement: DefaultFocusStatusModel,
    ): DefaultFocusStatusModel | null {
        if (this.isHybridGrid) {
            return this.findNextFocusableElementWithinNextVariableCommonForHybridGrid(
                currentElement,
            );
        }

        return this.findNextFocusableElementWithinNextVariableCommon(currentElement);
    }

    findLastFocusableElementWithinPreviousVariable(
        currentElement: DefaultFocusStatusModel,
    ): DefaultFocusStatusModel | null {
        const index = this.defaultFocusStatus.statuses.indexOf(currentElement);

        for (let i = index - 1; i >= 0; i--) {
            const elementFocusStatus = this.defaultFocusStatus.statuses[i];
            if (elementFocusStatus.variableId !== 0 &&
                elementFocusStatus.elementRef?.current &&
                elementFocusStatus.elementId !== currentElement.elementId &&
                // Skip non-focusable entries. An image choice's open-end textarea sits right
                // after its owning choice in the focus order (DEV-98343) but is rendered
                // `disabled` while that choice is unselected. Without this guard Shift+Tab
                // returned the disabled textarea, and the preventDefault()+focus() in
                // handleKeyPressEvent left focus stuck instead of reaching the previous
                // choice. Mirrors the isFocusable() check every other finder already applies.
                isFocusable(elementFocusStatus)) {
                return this.getFocusableElement(elementFocusStatus);
            }
        }
        return null;
    }
}
